import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// import AFB from './assets/fonts/AFB.ttf';

// const loadFonts = () => {
//   const head = document.getElementsByTagName('head')[0];
//   const style = document.createElement('style');
//   style.innerHTML = AFB;
//   head.appendChild(style);
// };

/* LEMBRANDO, DEIXAR React.StrictMode PARA MELHOR DEPURAÇÃO DO CÓDIGO EM DESENVOLVIMENTO, MESMO QUE ELE SEMPRE DÊ WARN, AINDA É DE EXTREMA IMPORTÂNCIA. Ant Design está dando erro de Ref*/ 
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
  // loadFonts
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();